
const data = {
  plano: null,
  desconto: {
    entrada: {},
    mensalidade: {},
    anuidade: {}
  },
  valor: {
    entrada: {},
    mensalidade: {},
    anuidade: {}
  }
}

const initialState = data

export const propostaValores = {
  namespaced: true,
  state: initialState,
  mutations: {
    save ( state, target ) {
      // this.data
      console.log("mutations state:", state)
      console.log("mutations target:", target)
    }
  },
  actions: {
    get () {
      return Promise.resolve(data)
    },
    save ({commit, state}, target) {
      commit('save', target)

      // console.log("target:", target)
      console.log("usable state:", state)
      console.log("usable target:", target)

      return Promise.resolve(target)
    }
  },
}

